import type { QuickSearchCategoryName, QuickSearchLanguage } from '@/types/searchTypes'

export const searchQueryKeys = {
  quickSearch: (season: string, normalizedQuery: string, lang: QuickSearchLanguage) => ['useQuickSearch', season, normalizedQuery, lang] as const,
  quickSearchCategoryInfinite: (season: string, normalizedQuery: string, category: QuickSearchCategoryName, lang: QuickSearchLanguage) => ['useQuickSearchCategoryInfinite', season, normalizedQuery, category, lang] as const,
  search: (query: string) => ['useSearch', query] as const,
}
